<template>
  <div id="report">
    <v-container fluid grid-list-lg>
      <v-data-iterator
        :items="inventory"
        :rows-per-page-items="rowsPerPageItems"
        content-tag="v-layout"
        hide-actions
        row
        wrap
      >
        <v-flex
          slot="item"
          slot-scope="props"
          xs12
          sm6
          md4
          lg3
        >
          <v-card>
            <v-card-title class="subheading font-weight-bold">{{ props.item.did }}</v-card-title>

            <v-divider></v-divider>

            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>Company:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.company }}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>E911 Address:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.e911address }}</v-list-tile-content>
              </v-list-tile>

            </v-list>
          </v-card>
        </v-flex>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import db from "./firebaseinit";
import firebase from 'firebase';
import { mapState, mapMutations } from 'vuex'
var Tabulator = require("tabulator-tables"); //import Tabulator library


export default {
  name: "report",
  data() {
    return {
      search: "",
      dialog: false,
      inventory: [],
      did: null,
      users: [],
      Admin: false,
      Standard: false,
      tabulator: null, //variable to hold your table
      exporting: false,
      tableData: [
      ], //data for table to display
    };
  },
  watch:{
    //update table if data changes

  },
  created() {
    var that = this
    db.collection("inventory")
      .where('e911', '==', true)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company,
            'devicetype': doc.data().devicetype,
            'did': doc.data().did,
            'tempdid': doc.data().tempdid,
            'e911': doc.data().e911,
            'e911address': doc.data().e911address,
            'extension': doc.data().extension,
            'notes': doc.data().notes,
            'user': doc.data().user
          };
          this.inventory.push(data);
          console.log(data)
        });
      });
      if(firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      //Gets User Group//
      console.log(this.currentUser)
      console.log(this.users)
      var user = this.currentUser
      var a = this.users.indexOf(user)
      console.log(a)
      };
      var users = db.collection("users")
      .orderBy("user")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'user': doc.data().user,
            'admin': doc.data().admin,
            'standard': doc.data().standard
          };
          this.users.push(data);
        });
      });
     var query = firebase.firestore().collection('users')
      .where("user", '==', this.currentUser)
      .get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
        console.log(doc.data())
        this.admin = doc.data().admin
        this.standard = doc.data().standard
        this.permissions = true
        })
        console.log("Admin: " + this.admin)
        console.log("Standard: " + this.standard)
        console.log(this.currentUser)
      });
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Report.vue